import { ISwapCounts } from "./swap-counts";

export interface ISwapCountResponse {
    data: {
        success: boolean;
        results: ISwapCounts;
    }
}
